import LSF from '@@Storefront';
import React from 'react';
import Icon from '@@Components/Icon/Icon';
import { ToastContent, ToastIcon, ToastWrapper } from '@@Components/Toast/styled';
export const Toast = (props) => {
    function closeNotification() {
        LSF.NotificationService.removeById(props.id);
    }
    return (React.createElement(ToastWrapper, { onClick: () => closeNotification(), type: props.type },
        React.createElement(ToastIcon, null,
            React.createElement(Icon, { icon: props.type, width: 20, height: 20 })),
        React.createElement(ToastContent, null, props.children)));
};
